<template>
  <figure class="phone-frame" :class="{ 'is-mock': !screenshot.image }">
    <img
      v-if="screenshot.image"
      :src="screenshot.image"
      :alt="screenshot.alt || screenshot.title"
      loading="lazy"
    />
    <div v-else class="mock-app" :class="`mock-${screenshot.mock || 'dashboard'}`">
      <div class="mock-status">
        <span></span>
        <span></span>
      </div>
      <div class="mock-title">{{ screenshot.title }}</div>
      <div class="mock-metrics">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="mock-list">
        <span v-for="item in 5" :key="item"></span>
      </div>
    </div>
  </figure>
</template>

<script>
export default {
  name: 'PhoneFrame',
  props: {
    screenshot: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.phone-frame {
  overflow: hidden;
  width: min(224px, 72%);
  aspect-ratio: 1080 / 2376;
  margin: 0;
  border: 7px solid #fff;
  border-radius: 30px;
  background: #fff;
  box-shadow: 0 18px 44px rgba(61, 24, 8, 0.18);

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
  }
}

.mock-app {
  height: 100%;
  padding: 18px 14px;
  color: #172033;
  background: linear-gradient(180deg, #f8fbff 0%, #eef6f4 100%);
}

.mock-status {
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;

  span {
    width: 42px;
    height: 8px;
    border-radius: 99px;
    background: #dfe9ee;
  }
}

.mock-title {
  min-height: 52px;
  padding: 16px 14px;
  border-radius: 16px;
  color: #fff;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
  background: linear-gradient(135deg, #1f7a5b, #2a9d8f);
}

.mock-metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin: 14px 0;

  span {
    height: 48px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 8px 22px rgba(20, 79, 76, 0.08);
  }
}

.mock-list {
  display: grid;
  gap: 10px;

  span {
    height: 46px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 8px 22px rgba(20, 79, 76, 0.08);
  }
}

.mock-inventory .mock-title {
  background: linear-gradient(135deg, #315f88, #3d8fb0);
}

.mock-live .mock-title {
  background: linear-gradient(135deg, #8d210a, #ff8a00);
}

.mock-fulfillment .mock-title {
  background: linear-gradient(135deg, #424b5f, #7b879a);
}

@media (max-width: 640px) {
  .phone-frame {
    width: min(210px, 70vw);
    border-width: 6px;
    border-radius: 26px;
  }

  .mock-app {
    padding: 16px 12px;
  }

  .mock-title {
    min-height: 48px;
    padding: 14px 12px;
    font-size: 16px;
  }
}
</style>
